import React from 'react'
import './AwesomeFurniture.css'

export const Unmatched = () => {
  return (
    <div className='showContainer'>
            <div className='showContainerLeft'>
                <img src="https://assets.furlenco.com/image/upload/dpr_1.0,f_auto,q_auto/v1/s3-furlenco-images/hulk/home/unmatched_quality.png" alt="img" />
            </div>

            <div className='showContainerright'>
                <h2>BUILT TO LAST</h2>
                <p>We understand the effort that goes into making a house a home. That’s why our delivery executives deliver not just the furniture but do also the entire setup, leaving your home just the way you always wante</p>
                <button>Explore Products</button>
            </div>
        </div>
  )
}
